import { gql } from '@apollo/client';
import TASK_LIST_TEMPLATE_FRAGMENT from './TaskListTemplateFragment.graphql';
import TaskListSectionlessTemplateFragment from 'components/projects/taskList/gql/fragments/TaskListSectionlessTemplateFragment.graphql';
import TaskListSectionsTemplateFragment from 'components/projects/taskList/gql/fragments/TaskListSectionsTemplateFragment.graphql';

const GET_TASK_LIST_TEMPLATE = gql`
  query GetTaskListTemplate($id: ID!) {
    viewer {
      __typename
      id
      taskListTemplate(id: $id) {
        __typename
        ...TaskListTemplateFragment
      }
    }
  }
  ${TASK_LIST_TEMPLATE_FRAGMENT}
`;

const GET_TASK_LIST_TEMPLATE_SECTIONLESS = gql`
  query GetTaskListTemplateSectionless($id: ID!) {
    viewer {
      __typename
      id
      taskListTemplate(id: $id) {
        __typename
        ...TaskListSectionlessTemplateFragment
      }
    }
  }
  ${TaskListSectionlessTemplateFragment}
`;

const GET_TASK_LIST_TEMPLATE_SECTIONS = gql`
  query GetTaskListTemplateSections($id: ID!) {
    viewer {
      __typename
      id
      taskListTemplate(id: $id) {
        __typename
        ...TaskListSectionsTemplateFragment
      }
    }
  }
  ${TaskListSectionsTemplateFragment}
`;

export {
  GET_TASK_LIST_TEMPLATE_SECTIONLESS,
  GET_TASK_LIST_TEMPLATE_SECTIONS,
}

export default GET_TASK_LIST_TEMPLATE;
